import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=012474cc&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Brands.vue?vue&type=style&index=1&id=012474cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012474cc",
  null
  
)

export default component.exports